import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RefreshJobsButtonComponent } from './refresh-jobs-button.component';

@NgModule({
  exports: [RefreshJobsButtonComponent],
  declarations: [RefreshJobsButtonComponent],
  imports: [CommonModule, MatButtonModule, MatTooltipModule, FontAwesomeModule, MatProgressSpinnerModule],
})
export class RefreshJobsButtonModule {}
